import EventBodyWithTabs, {
  htmlContent,
} from '@/components/client/events/EventBodyWithTabs'
import EventHero from '@/components/client/events/EventHero'
import ClientLayout from '@/components/client/layout/Index'
import {
  AnalyticsDocument,
  CoursesPathsDocument,
  EventDetailsOutputDocument,
} from '@/types/graphql/types'
import { useMutation, useQuery } from '@apollo/client'
import { initializeApollo } from 'lib/apolloClient'
import { parseInt } from 'lodash'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import InfinityLoader from '@/components/common/infinityLoader'
import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'
import useEvent from '@/hooks/client/Event/useEvent'
import WhatsApp from '@/components/client/contact/WhatsApp' // Import WhatsApp component
import SponsorshipCarousel from '../events/SponsorshipCarousel'

const EventPageContent = () => {
  const { t, lang } = useTranslation('client')
  const isArabic = lang === 'ar'
  const { data } = useEvent()
  return (
    <>
      {data ? (
        <>
          <NextSeo
            additionalMetaTags={[
              {
                name: 'keywords',
                content: data?.EventDetailsOutput?.keywordsEn?.join(',') ?? '',
              },
            ]}
            title={`${
              (isArabic
                ? data?.EventDetailsOutput?.titleAr
                : data?.EventDetailsOutput?.titleEn) ||
              htmlContent(
                data?.EventDetailsOutput.shortDescriptionAr ||
                  data?.EventDetailsOutput.shortDescriptionEn,
              )
            } - ${t('appName')}`}
            description={
              htmlContent(
                data?.EventDetailsOutput.descriptionEn ||
                  data?.EventDetailsOutput.shortDescriptionAr ||
                  data?.EventDetailsOutput.shortDescriptionEn,
              ) ||
              data?.EventDetailsOutput?.titleAr ||
              data?.EventDetailsOutput?.titleEn ||
              ''
            }
            canonical={`https://infinity.edu.sa/${
              isArabic ? 'ar' : 'en'
            }/event/${data?.EventDetailsOutput.id}`}
            openGraph={{
              url: `https://infinity.edu.sa/${isArabic ? 'ar' : 'en'}/event/${
                data?.EventDetailsOutput.id
              }`,
              title: `${
                data?.EventDetailsOutput?.titleAr ||
                data?.EventDetailsOutput?.titleEn ||
                htmlContent(
                  data?.EventDetailsOutput.shortDescriptionAr ||
                    data?.EventDetailsOutput.shortDescriptionEn,
                )
              }`,
              description: `${
                htmlContent(
                  data?.EventDetailsOutput.shortDescriptionAr ||
                    data?.EventDetailsOutput.shortDescriptionEn,
                ) ||
                data?.EventDetailsOutput?.titleAr ||
                data?.EventDetailsOutput?.titleEn
              }`,
              images: data?.EventDetailsOutput.backgroundImagesUrls?.map(
                image => ({
                  url: image || '-',
                }),
              ),
            }}
          />
          <EventHero
            images={
              (data?.EventDetailsOutput.backgroundImagesUrls as any) ?? []
            }
          />
          {data?.EventDetailsOutput?.isSponsored && (
            <SponsorshipCarousel
              slides={data?.EventDetailsOutput?.sponsorshipImagesUrls}
            />
          )}
          <EventBodyWithTabs />
          <WhatsApp /> {/* Add WhatsApp component here */}
        </>
      ) : (
        <div className="flex justify-center">
          <InfinityLoader variant="md" />
        </div>
      )}
    </>
  )
}

export default EventPageContent
